module.exports = __webpack_public_path__ + "img/13ff45a0e38d9fc15ce2fca999ccb8aa.2fe694af.png";